import { PopupService } from '../services/popup.service';
import { textValidation } from '../utility/ValidatorFunctions';

declare var $: any;

export const AddProject = (partnerList, service: PopupService) => {
  let inputHTMLFields: string =
    '<div class="form-group"><input id="swal-input-name" type="text" class="form-control" placeholder="Projekt neve"/></div><div class="form-group"><select id="swal-input-partner" class="form-control"/>';
  partnerList.map(function (partnerObject) {
    inputHTMLFields += `<option value="${partnerObject.id}">${partnerObject.name}</option>`;
  });

  inputHTMLFields += '</div>';

  return {
    title: 'Új projekt hozzáadása választott partnerhez',
    html: inputHTMLFields,
    showCancelButton: true,
    reverseButtons: true,
    allowOutsideClick: false,
    customClass: {
      actions: 'popup-buttons',
      confirmButton: 'btn btn-primary mat-raised-button mat-button-base',
      cancelButton:
        'btn btn-primary btn-link mat-raised-button mat-button-base',
    },
    buttonsStyling: false,
    preConfirm: () => {
      const projectName = $('#swal-input-name').val();
      const partnerId = $('#swal-input-partner').val();

      if (!textValidation(projectName)) {
        return service.showValidationMessage('A név mező kitöltése kötelező!');
      }

      if (!textValidation(partnerId)) {
        return service.showValidationMessage(
          'Válasszon partnert, amelyhez a porjektet szeretné fűzni!'
        );
      }

      return {
        name: projectName,
        partnerId: partnerId,
      };
    },
  };
};
